export default __webpack_public_path__ + "static/media/visa.0d422d19.svg";